(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular2-modal"), require("@angular/core"));
	else if(typeof define === 'function' && define.amd)
		define(["angular2-modal", "@angular/core"], factory);
	else if(typeof exports === 'object')
		exports["angular2Modal.jsNative"] = factory(require("angular2-modal"), require("@angular/core"));
	else
		root["angular2Modal.jsNative"] = factory(root["angular2-modal"], root["@angular/core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition